import { ref } from 'vue';

// Współdzielony (singleton) stan wpisów AI (globalny dialog dyktowania w nagłówku).
// - createdSignal: rośnie po utworzeniu/zmianie wpisu — strony (Raport dnia, dashboard)
//   obserwują go i odświeżają dane.
// - *Draft/*DialogOpen: po odpowiedzi z /ai/entries otwieramy modal właściwego typu:
//     training → modal treningu (create + prefill; dane niezapisane),
//     sleep    → modal snu w trybie edycji (wpis już utworzony przez API — przegląd/poprawa),
//     meal     → modal posiłku (create + prefill),
//     edit     → modal edycji wpisu zapisanego przez API (zadanie, wydarzenie, wpis dnia).
// - Każde open* zwraca obietnicę z wynikiem: 'saved', 'deleted' albo 'closed' — podsumowanie
//   dyktowania aktualizuje po niej swoją kartę.
const createdSignal = ref(0);

const workoutDraft = ref(null);
const workoutDialogOpen = ref(false);

const sleepEditId = ref(null);
const sleepDialogOpen = ref(false);

const mealDraft = ref(null);
const mealDialogOpen = ref(false);

const editTarget = ref(null);   // { type, entry }

let resolvePending = null;
const pending = () => new Promise((resolve) => { resolvePending = resolve; });

export function useAiEntries() {
    const notifyCreated = () => { createdSignal.value++; };

    // Wynik otwartego modalu; kolejne wywołania (np. close po saved) nic już nie zmieniają.
    const settle = (result) => {
        const resolve = resolvePending;
        resolvePending = null;
        resolve?.(result);
    };

    const openWorkoutDraft = (data) => { workoutDraft.value = data ?? {}; workoutDialogOpen.value = true; return pending(); };
    const closeWorkoutDraft = () => { workoutDialogOpen.value = false; workoutDraft.value = null; settle('closed'); };

    const openSleepReview = (entry) => { sleepEditId.value = entry?.uuid ?? null; sleepDialogOpen.value = true; return pending(); };
    const closeSleepReview = () => { sleepDialogOpen.value = false; sleepEditId.value = null; settle('closed'); };

    const openMealDraft = (data) => { mealDraft.value = data ?? {}; mealDialogOpen.value = true; return pending(); };
    const closeMealDraft = () => { mealDialogOpen.value = false; mealDraft.value = null; settle('closed'); };

    const openEntryEdit = (type, entry) => { editTarget.value = { type, entry }; return pending(); };
    const closeEntryEdit = () => { editTarget.value = null; settle('closed'); };

    return {
        createdSignal, notifyCreated, settle,
        workoutDraft, workoutDialogOpen, openWorkoutDraft, closeWorkoutDraft,
        sleepEditId, sleepDialogOpen, openSleepReview, closeSleepReview,
        mealDraft, mealDialogOpen, openMealDraft, closeMealDraft,
        editTarget, openEntryEdit, closeEntryEdit,
    };
}
